<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
export default {};
</script>

<style lang="scss">
@import '~@/style/reset.scss';
body {
	background-color: #fff;
}
</style>
